import { render, staticRenderFns } from "./RegisterPoint.vue?vue&type=template&id=7d626e6c&"
import script from "./RegisterPoint.vue?vue&type=script&lang=js&"
export * from "./RegisterPoint.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPoint.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegisterPoint.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports